/** ************************* IMPORTANTE CONFIGURACION ************************* */

export var TIPO_CONEXION = "PRODUCCION";
//export var TIPO_CONEXION = "TESTING";
//export var TIPO_CONEXION = "DEVELOP";


/* Servicio - DocumentosFiscales */
export var Conexiones =
{         
     Copico : "",
     Aprosi : "",
     Comersur : ""     
}

// Servicio - ApiFacturacion
export var BASE_URL = "";

// Servicio - Envio de Correos
export const BASE_ENVIOCORREOS = "";

export class MConexiones{          
     obtenerConexion(){
          switch(TIPO_CONEXION)
          {
               case "PRODUCCION": 
                         /*BASE_URL = "http://187.141.69.2/servicesfacturacion/api/facturacion/";
                         Conexiones.Copico = "https://copicocorp.com/DocumentosFiscales/";
                         Conexiones.Aprosi = "https://copicocorp.com/DocumentosFiscalesAprosi/";
                         Conexiones.Comersur = "https://copicocorp.com/DocumentosFiscalesComersur/";*/
                         BASE_URL = "https://sic.copicocorp.com/servicesfacturacion/api/facturacion/";
                         Conexiones.Copico = "https://sic.copicocorp.com/services/api/";
                         Conexiones.Aprosi = "https://sic.aprosi.com.mx/services/api/";
                         Conexiones.Comersur = "https://sic.copicocorp.com/services/api/";
                    break;
               case "TESTING": 
                         BASE_URL = "http://services924.copicocorp.com/servicesfacturacion/api/facturacion/";
                         Conexiones.Copico = "http://services924.copicocorp.com/services/api/";
                         Conexiones.Aprosi = "http://192.168.9.26/services/api/";
                         Conexiones.Comersur = "http://services924.copicocorp.com/services/api/";
                    break;
               case "DEVELOP":
                         // BASE_URL = "http://192.168.9.115/apifacturacion/public/api/facturacion/";
                         // Conexiones.Copico = "http://192.168.9.115/DocumentosFiscales/";
                         // Conexiones.Aprosi = "http://192.168.9.115/DocumentosFiscales/";
                         // Conexiones.Comersur = "http://192.168.9.115/DocumentosFiscales/";
                         BASE_URL = "http://127.0.0.1/apifacturacion/public/api/facturacion/";
                         Conexiones.Copico = "http://127.0.0.1/apicopico/public/api/";
                         Conexiones.Aprosi = "http://127.0.0.1/apicopico/public/api/";
                         Conexiones.Comersur = "http://127.0.0.1/apicopico/public/api/";
                    break;
          }
     }
}